// SEO helpers (dependency-free). Single source for URL + locale logic.
export const SITE = "https://sa-v.co";
export const LOCALES = ["en", "ar"];
export const DEFAULT_LOCALE = "en";

// Prefix an internal path with the active locale. Leaves external / mailto / tel / hash-only intact-ish.
export const withLocale = (lang, to) => {
  if (!to) return `/${lang}`;
  if (/^(https?:|mailto:|tel:)/.test(to)) return to;
  if (to.startsWith("#")) return `/${lang}#${to.slice(1)}`;
  const [p, hash] = to.split("#");
  const clean = !p || p === "/" ? "" : (p.startsWith("/") ? p : `/${p}`);
  return `/${lang}${clean}${hash ? `#${hash}` : ""}`;
};

// Given a full pathname like /en/services/vat-registration-uae -> strip locale => /services/...
export const stripLocale = (pathname) => {
  const m = pathname.match(/^\/(en|ar)(\/.*)?$/);
  return m ? (m[2] || "/") : pathname;
};

// Swap the locale in a pathname (for the language toggle), keeping the rest.
export const swapLocale = (pathname, lang) => `/${lang}${stripLocale(pathname) === "/" ? "" : stripLocale(pathname)}`;

export const OG_IMAGE = `${SITE}/og-image.png`;

export const orgSchema = {
  "@context": "https://schema.org",
  "@type": ["AccountingService", "ProfessionalService"],
  "@id": `${SITE}/#organization`,
  name: "Smart Account Vision Tax Consultant",
  alternateName: ["Smart Account Vision", "سمارت أكاونت فيجن للاستشارات الضريبية", "SAV"],
  url: SITE,
  logo: `${SITE}/logo.png`,
  image: OG_IMAGE,
  email: "info@sa-v.co",
  telephone: "+971565248900",
  areaServed: "AE",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Sharjah Research Technology and Innovation Park",
    addressLocality: "Sharjah",
    addressCountry: "AE",
  },
  sameAs: [
    "https://www.facebook.com/p/Smart-Account-Vision-61552738853815/",
    "https://ae.linkedin.com/in/smart-account-vision-421695297",
    SITE,
  ],
};
